/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryUpdateResource
 */
export interface CategoryUpdateResource {
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdateResource
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdateResource
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdateResource
     */
    categoryName: string;
}

/**
 * Check if a given object implements the CategoryUpdateResource interface.
 */
export function instanceOfCategoryUpdateResource(value: object): value is CategoryUpdateResource {
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('categoryName' in value) || value['categoryName'] === undefined) return false;
    return true;
}

export function CategoryUpdateResourceFromJSON(json: any): CategoryUpdateResource {
    return CategoryUpdateResourceFromJSONTyped(json, false);
}

export function CategoryUpdateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryUpdateResource {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'],
        'categoryId': json['categoryId'],
        'categoryName': json['categoryName'],
    };
}

export function CategoryUpdateResourceToJSON(value?: CategoryUpdateResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileId': value['profileId'],
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
    };
}

